import { render, staticRenderFns } from "./HCaptchaV1.vue?vue&type=template&id=4bf56999&"
import script from "./HCaptchaV1.vue?vue&type=script&lang=js&"
export * from "./HCaptchaV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports